import type { ReactNode } from 'react';

const ENVIRONMENT_ARIA_LABELS = {
  new: { ja: '新環境', en: 'New environment' },
  old: { ja: '旧環境', en: 'Old environment' },
} as const;

export function ProductEnvironmentBadge({ environment, locale }: { environment: 'new' | 'old'; locale: 'ja' | 'en' }): ReactNode {
  return (
    <span
      role="img"
      aria-label={ENVIRONMENT_ARIA_LABELS[environment][locale]}
      className={`absolute -bottom-[6px] left-1/2 h-4 w-7 -translate-x-1/2 rounded text-center text-[9px] font-bold leading-4 text-[#fff] ${environment === 'old' ? 'bg-[#9DA4AE]' : 'bg-[#F25320]'}`}
    >
      {environment === 'new' ? 'New' : 'Old'}
    </span>
  );
}
